// extracted by mini-css-extract-plugin
export default {"resizeLine":"resize-table-line_resizeLine__EpWhe"};